import { FertilityJourneyExplainer } from "./fertility-journey/explainer-1";
import { FertilityJourneyExplainer2 } from "./fertility-journey/explainer-2";
import { FertilityTransitionsExplainer2 } from "./fertility-transitions/explainer-2";
import { HealthConditionsExplainer2 } from "./health-conditions/explainer-2";
import RegularCycleAnalysis1 from "./regular-cycle/regular-cycle-1";
import RegularCycleAnalysis2 from "./regular-cycle/regular-cycle-2";
import RegularCycleAnalysis4 from "./regular-cycle/regular-cycle-4";
import { TryingDurationExplainer1 } from "./trying-duration/explainer-1";
import { TryingDurationExplainer2 } from "./trying-duration/explainer-2";
import { TryingDurationExplainer3 } from "./trying-duration/explainer-3";
import UsedProductsExplainer from "./used-products/explainer";

export const explainers: Record<string, React.ComponentType<any>> = {
  "fertility-journey-analysis-1": FertilityJourneyExplainer,
  "fertility-journey-analysis-1.1": FertilityJourneyExplainer,
  "fertility-journey-analysis-2": FertilityJourneyExplainer2,
  "trying-duration-analysis-1": TryingDurationExplainer1,
  "trying-duration-analysis-1.1": TryingDurationExplainer1,
  "trying-duration-analysis-2": TryingDurationExplainer2,
  "trying-duration-analysis-3": TryingDurationExplainer3,
  "fertility-transitions-analysis-1": TryingDurationExplainer1,
  "fertility-transitions-analysis-1.1": TryingDurationExplainer1,
  "fertility-transitions-analysis-1.2": TryingDurationExplainer1,
  "fertility-transitions-analysis-2": FertilityTransitionsExplainer2,
  "fertility-transitions-analysis-2.1": FertilityTransitionsExplainer2,
  "fertility-transitions-analysis-2.2": FertilityTransitionsExplainer2,
  "health-conditions-analysis-1": TryingDurationExplainer1,
  "health-conditions-analysis-1.1": TryingDurationExplainer1,
  "health-conditions-analysis-1.2": TryingDurationExplainer1,
  "health-conditions-analysis-2": HealthConditionsExplainer2,
  "health-conditions-analysis-2.1": HealthConditionsExplainer2,
  "health-conditions-analysis-2.2": HealthConditionsExplainer2,
  "health-conditions-analysis-1.3": TryingDurationExplainer1,
  "health-conditions-analysis-2.3": HealthConditionsExplainer2,
  "used-products-analysis-1": UsedProductsExplainer,
  "used-products-analysis-1.1": UsedProductsExplainer,
  "used-products-analysis-1.2": UsedProductsExplainer,
  "used-products-analysis-1.3": UsedProductsExplainer,
  "used-products-analysis-1.4": UsedProductsExplainer,
  "used-products-analysis-1.5": UsedProductsExplainer,
  "used-products-analysis-1.6": UsedProductsExplainer,
  "regular-cycle-analysis-1": RegularCycleAnalysis1,
  "regular-cycle-analysis-2": RegularCycleAnalysis2,
  "regular-cycle-analysis-3": TryingDurationExplainer1,
  "regular-cycle-analysis-4": RegularCycleAnalysis4,
};
